/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCulturalExperienceTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCulturalExperience,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Explore New Cultures!",
    "Cultural Adventure Awaits!",
    "Let’s Discover Together!",
  ],
  title: "Cultural Experience",
  description: "Organize a fun cultural experience outing.",
  longDescription:
    "Gather your friends for an enriching cultural experience! Choose a date, select the cultural event or exhibit, and plan a meal to enjoy!",
  emoji: "🌍",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Cultural Experience",
          emoji: "🌍",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go for the cultural experience?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a cultural event to attend?",
            description: "What cultural event or exhibit should we visit?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What event should we choose?",
                emoji: "🎭",
                completeAction: {
                  question: "Decide on a meal to enjoy afterward?",
                  description:
                    "Where should we eat after the cultural experience?",
                  addModules: [
                    {
                      type: ModuleType.Location,
                      doneType: ModuleDoneType.Voting,
                      title: "Where should we eat?",
                      emoji: "🍽",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Enjoy the Experience!",
    outroDescription:
      "Your cultural experience plans are set! Enjoy discovering new things!",
  },
};
